import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { objectId } from '@/shared/validations/custom.validation';
import File from './files.model';

export const createFile = () => ({
  body: {
    category: Joi.string().required(),
    project: Joi.string().custom(objectId).required(),
    name: Joi.string().required(),
    size: Joi.string().required(),
    fileType: Joi.string().required(),
    fileUrl: Joi.string().required(),
    description: Joi.string().allow('', null),
  },
});

export const updateFile = () => ({
  params: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(File.schema, true),
});

export const getFiles = {
  query: Joi.object().keys({
    name: Joi.string(),
    category: Joi.string(),
    project: Joi.string().custom(objectId),
    size: Joi.string(),
    createdBy: Joi.string().custom(objectId),
    status: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getFileById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteFileById = {
  params: Joi.object().keys({
    projectId: Joi.string().custom(objectId),
    id: Joi.string().custom(objectId),
  }),
};
